import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { ActivatedRoute, Router } from '@angular/router';
import { SetIsImpersonating } from '@core/util/local-storage';
import { take } from 'rxjs/operators';

@Component({
	selector: 'app-impersonate',
	templateUrl: './impersonate.component.html',
	standalone: false,
})
export class ImpersonateComponent implements OnInit {
	public uid: string;
	public businessId: string;
	public loading = false;
	public error;
	public matterId: string;

	constructor(
		private fns: AngularFireFunctions,
		private auth: AngularFireAuth,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private destroyRef: DestroyRef,
	) {}

	ngOnInit(): void {
		this.activatedRoute.queryParams
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((params) => {
				this.businessId = params['businessId'];
				this.uid = params['userId'];
				this.matterId = params['matterId'];
			});
	}

	async impersonate() {
		try {
			this.error = false;
			this.loading = true;
			const callable = this.fns.httpsCallable('businessUser_impersonate');

			const result = await callable({
				uid: this.uid,
				businessId: this.businessId,
			})
				.pipe(take(1))
				.toPromise();
			await this.auth.signInWithCustomToken(result);

			SetIsImpersonating(true);

			if (this.matterId) {
				void this.router.navigate([`/app/matter/${this.matterId}`]);
			} else {
				void this.router.navigate(['/app']);
			}
		} catch (err) {
			console.log('Unable to get login token', err);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}
}
